import React from "react";
import { NavLink } from "react-router-dom";
export const Counter = ({ label, count, text, icon, link, bg }) => {
  return (
    <>
      <div class={`rounded-xl bg-white border shadow-sm`}>
        <NavLink
          to={link}
          className={" flex items-center justify-between p-4 "}
        >
          <div class="">
            <h3 class="tracking-tight text-[13px] text-gray-600">{label}</h3>
            <p class="font-mtn mt-1 text-2xl  font-semibold">{count}</p>
            <div className="flex flex-row items-center space-x-2">
              {/* <p class="text-xs text-green-800">{text}</p> */}
              {/* <p className='text-xs font-semibold bg-amber-300 px-3 rounded text-black'>+1</p> */}
            </div>
          </div>
          <div
            class={`flex-shrink-0 flex justify-center items-center size-[46px] bg-amber-100 rounded-full`}
          >
            {icon}
          </div>
        </NavLink>
      </div>
    </>
  );
};
